module.exports = __webpack_public_path__ + "static/media/icon.d3293327.webp";